<template>
  <div v-if="visible" class="loading">
    <div class="loading-box">
      <img src="./img/loading.png" class="loading-img" />
      <div class="loading-font">正在加载中...</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      visible: false
    }
  },
  methods: {
    addOption (option) {
      this.visible = option.visible
    }
  }
}
</script>
<style lang="less" scoped>
.loading {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // background: red;
  z-index: 999999;
  .loading-box {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -61px;
    margin-left: -64px;
    border-radius: 4px;
    width: 128px;
    height: 122px;
    background: rgba(0, 0, 0, .75);
    opacity: .8;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .15);
    .loading-img {
      margin-top: 24px;
      margin-left: 48px;
      width: 32px;
      height: 32px;
    }
    .loading-font {
      position: absolute;
      right: 0;
      bottom: 22px;
      left: 0;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      text-align: center;
      color: #fff;
    }
  }
}
@-webkit-keyframes rotate {
  from { -webkit-transform: rotate(0deg); }
  to { -webkit-transform: rotate(360deg); }
}
@-moz-keyframes rotate {
  from { -moz-transform: rotate(0deg); }
  to { -moz-transform: rotate(359deg); }
}
@-o-keyframes rotate {
  from { -o-transform: rotate(0deg); }
  to { -o-transform: rotate(359deg); }
}
@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(359deg); }
}
.loading-img {
  -webkit-transition-duration: 1s;
  -moz-transition-duration: 1s;
  -webkit-transition-property: -webkit-transform;
  -moz-transition-property: -moz-transform;
  -webkit-animation: rotate 1s linear infinite;
  -moz-animation: rotate 1s linear infinite;
  -o-animation: rotate 1s linear infinite;
  animation: rotate 1s linear infinite;
}
</style>
